// src/features/competitor/updateCompetitorCampaignSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../httpService/httpService";

// Async thunk for updating a competitor campaign
export const updateCompetitorCampaign = createAsyncThunk(
  "competitor/updateCompetitorCampaign",
  async (
    {
      competitor_id,
      competitor_campaign_id,
      competitor_campaign_name,
      industry_type,
    },
    { rejectWithValue }
  ) => {
    try {
      const token = localStorage.getItem("authToken");

      // Create payload for the request
      const payload = {
        competitor_id,
        competitor_campaign_id,
        competitor_campaign_name,
        industry_type,
      };

      const response = await axiosInstance.put(
        `/update-competitor-campaign/admin/appsells/`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        return {
          data: response.data,
          headers: {
            contentType: response.headers["content-type"],
            contentLength: response.headers["content-length"],
          },
        };
      } else {
        throw new Error(
          `Update Competitor Campaign failed with status: ${response.status}`
        );
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "An error occurred while updating"
      );
    }
  }
);

const updateCompetitorCampaignSlice = createSlice({
  name: "updateCompetitorCampaign",
  initialState: {
    competitor: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    resetUpdateStatus: (state) => {
      state.competitor = null;
      state.isLoading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateCompetitorCampaign.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateCompetitorCampaign.fulfilled, (state, action) => {
        state.isLoading = false;
        state.competitor = action.payload;
        state.error = null;
      })
      .addCase(updateCompetitorCampaign.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateStatus } = updateCompetitorCampaignSlice.actions;

export default updateCompetitorCampaignSlice.reducer;
